import TimeEntryProfileList from "./list";


if (document.body.getAttribute("data-current-path") === "teams/time_entry_profiles") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new TimeEntryProfileList();
    }
}